module.exports = __webpack_public_path__ + "img/shop_top_point.2ca6c7d9.png";